import { Bootstrap } from "made-this-ui";
import Head from "next/head";
import { AppProps } from "next/app";
import themeAdmin from "admin/lib/theme";

export const RequestsApp = ({ Component, pageProps }: AppProps) => {
  return (
    <Bootstrap theme={themeAdmin}>
      <Head>
        <title>Ejsingholm</title>
        <meta name="viewport" content="width=device-width, initial-scale=1" />
      </Head>

      <Component {...pageProps} />
    </Bootstrap>
  );
};
